import Vue from 'vue'
import Vuex from 'vuex'
import { getUserInfo } from '@/api/user'
import { getToken, setToken } from '@/http/tools'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    hasLogin: false,
    userInfo: null,
    token: null,
    aliSts: null
  },
  mutations: {
    setAliSts (state, data) {
      state.aliSts = data
    },
    setUserInfo (state, userInfo) {
      console.log(state, userInfo, 'state更新用户信息')
      state.userInfo = userInfo
      global.userInfo = userInfo
    },
    setToken (state, token) {
      state.hasLogin = true
      state.token = token
      global.token = token
      console.log(global.token, '=========token=========')
      setToken(token)
    },
    login (state, userInfo) {
      state.userInfo = userInfo
      global.userInfo = userInfo
      state.hasLogin = true
    },
    logout (state) {
      state.hasLogin = false
      state.token = ''
      global.token = ''
      setToken('')
      // setUserInfo(null)
      // setUserInfo(null)
      // commit('setToken', '')
      // commit('setUserInfo', null)
    }
  },
  actions: {
    init ({ commit }) {
      if (getToken()) {
        getUserInfo().then(res => {
          this.hasLogin = true
          console.log(res, 'res====初始化=====')
          localStorage.setItem('USERINFO', JSON.stringify(res.data.data))
          commit('login', res.data.data)
          // resolve(res.data.data)
        }).catch(err => {
          console.log(err)
          // reject(err)
        })
      }
    },
    // 登录
    login ({ commit }, data) {
      console.log(data, '======login=====data')
      commit('setUserInfo', data.data)
      commit('setToken', data.api_auth)
    },
    // 获取用户相关信息
    getUserInfo ({ state, commit }, force = false) {
      return new Promise((resolve, reject) => {
        try {
          if (!force && state.userInfo && JSON.stringify(state.userInfo) !== '{}') {
            resolve(state.userInfo)
            return
          }
          getUserInfo().then(res => {
            commit('setUserInfo', res.data.data)
            resolve(res.data.data)
          }).catch(err => {
            reject(err)
          })
        } catch (error) {
          reject(error)
        }
      })
    }
  }
})
